export type DenyInfoJSON = DenyInfo

export type DenyInfo = {
  key: string
  name: string
}

export class DenyInfoDTO implements DenyInfo {
  constructor(public key: string, public name: string) {
  }

  static fromJSON(jsonObject: DenyInfoJSON): DenyInfoDTO {
    return new DenyInfoDTO(
      jsonObject.key,
      jsonObject.name,
    )
  }
}

export type UnionDenyInfoJSON = UnionDenyInfo

export type UnionDenyInfo = DenyInfo & {
  id: number
}

export class UnionDenyInfoDTO implements UnionDenyInfo {
  id: number
  key: string
  name: string

  constructor(id: number, key: string, name: string) {
    this.id = id
    this.key = key
    this.name = name
  }

  static fromJSON(jsonObject: UnionDenyInfoJSON): UnionDenyInfoDTO {
    return new UnionDenyInfoDTO(
      jsonObject.id,
      jsonObject.key,
      jsonObject.name,
    )
  }
}
